import React, { Component } from 'react';
import ReactMarkdown from 'react-markdown';
import { connect } from 'react-redux';
import DocumentMeta from 'react-document-meta';
import { setCitySlug } from '../redux/modules/cities';
import { adjustBoligagent } from '../redux/modules/boligagents';
import {
  getCityDwellings,
  dwellingsIsLoaded
} from '../redux/modules/dwellings';
import { Grid } from 'react-bootstrap';
import EmailSignup from '../common/email-signup';
import DwellingsList from './dwellings-list';
import i18n from 'kodyl-js/i18n/react';
import NotFound from '../common/not-found';
import Faq from './faq';

const BoligAgentModal = __CLIENT__
  ? require('app/boligagent/modal').default
  : null;

@connect(
  ({
    cities,
    auth: { user },
    dwellings: { content, meta, data, firstView, loading },
    boligagents
  }) => ({
    city: cities.current,
    user,
    boligagent: boligagents.current,
    meta,
    loading,
    content,
    cities: cities.list,
    dwellings: { data, firstView, loading }
  }),
  { adjustBoligagent }
)
@i18n
class AreaPage extends Component {
  static fetchData({ getState, dispatch, params, reload, location }) {
    const promise = Promise.resolve().then(async () => {
      const { query } = location;
      const currentState = getState();
      let citySlug = params.city;
      const path = `/area/${params.city}`;

      if (reload || !dwellingsIsLoaded(currentState, path)) {
        const { type, payload } = await dispatch(
          getCityDwellings(params.city, { reload, query })
        );
        try {
          if (
            type === 'dwellings/LOAD_SUCCESS' &&
            payload.meta &&
            payload.meta.query &&
            payload.meta.query.area
          ) {
            citySlug = payload.meta.query.area;
          }
        } catch (err) {
          console.error(err);
        }
        await dispatch(setCitySlug(citySlug));
      } else if (!currentState.cities.current) {
        await dispatch(setCitySlug(citySlug));
      }
    });

    return __CLIENT__ ? null : promise;
  }

  componentDidMount() {
    const { city } = this.props;
    if (city && city.slug) {
      const { adjustBoligagent, boligagent, user } = this.props;
      adjustBoligagent({ area: city.slug, current: boligagent, user });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.city &&
      nextProps.city.slug &&
      (!this.props.city || this.props.city.slug !== nextProps.city.slug)
    ) {
      const {
        adjustBoligagent,
        boligagent,
        user,
        city: { slug: area }
      } = nextProps;
      adjustBoligagent({ area, current: boligagent, user });
    }
  }

  render() {
    const { city, meta, dwellings } = this.props;

    if (!city && !this.props.content && !meta.results) {
      return <NotFound />;
    }

    const content = this.props.content || {};

    const results = meta.results > 10 ? meta.results : '';
    const title =
      (content.meta && content.meta.title) ||
      this.i18n(
        'Lejebolig %1$s: %2$s ledige lejligheder til leje',
        (city && city.label) || '',
        results
      );
    const docMeta = {
      title: `${title}${title.length < 45 ? '. Boligninja.dk' : ''}`,
      description:
        (content.meta && content.meta.description) ||
        this.i18n(
          'Find din nye lejebolig i %1$s. Lige nu finder du %2$s ledige lejligheder og boliger i %1$s på Boligninja.dk som du kan leje.',
          (city && city.label) || '',
          results
        ),
      extend: true,
      auto: {
        ograph: true
      }
    };

    return (
      <DocumentMeta {...docMeta}>
        {BoligAgentModal && city && (
          <BoligAgentModal areaName={city.label} areaSlug={city.slug} />
        )}
        <div className="content">
          <Grid className="listings-container">
            <h1>
              {content.headline ||
                this.i18n(
                  'Rental dwellings %1$s - listing all available dwellings near %1$s',
                  (city && city.label) || ''
                )}
            </h1>

            {content.teaser ? <ReactMarkdown source={content.teaser} /> : null}

            {city && <EmailSignup area={city} city={city.label} headline />}

            <DwellingsList
              headline={this.i18n('Dwellings found: %s', meta.results || '...')}
              {...dwellings}
              totalResults={meta.results}
            />

            <br />
            {city && results ? (
              <EmailSignup area={city} city={city.label} />
            ) : null}
            {city && meta && dwellings.data && (
              <>
                <Faq city={city} meta={meta} dwellings={dwellings.data} />
                <div>
                  <a
                    target="_blank"
                    href={`https://www.akutbolig.dk/${city.slug}`}
                  >
                    Se flere lejeboliger i {city.label} på Akutbolig.dk
                  </a>
                </div>
                <hr />
              </>
            )}

            {content.main ? (
              <div style={{ margin: '15px 0px' }}>
                {city &&
                  `Er du husvild og søger akut bolig i ${
                    city.label
                  }? Surf løs på
                    vores boligportal og find bolig nu, eller tilmeld dig vores
                    BoligAgent under afsnittet: 'min lejebolig' på din
                    profilside, hvor du kan angive dine boligønsker i ${
                      city.label
                    },
                    som lejlighed, hus, rækkehus, værelse eller om du vil finde
                    en roommate. \nHerefter får du e-mails hver gang der kommer
                    nye ledige boliger til leje her på boligsiden Boligninja.dk
                    indtil du afmelder dig. \n`}
                <ReactMarkdown source={content.main} />
              </div>
            ) : null}
          </Grid>
        </div>
      </DocumentMeta>
    );
  }
}

export default AreaPage;
